<template lang="pug">
	.v-add-employe-form.add-employe-form(v-if="data" )
		v-form(:data-source="data")
</template>

<script>
import sourceMixin from '../components/mixins/v-mixin-source.vue';
export default {
	mixins: [
		sourceMixin,
	],

	data() {
		return {
			data: null
		};
	},

	methods: {
		dataSet(data) {
			this.data = data;
		}
	}
};
</script>